import { FC } from "react";
import { useTranslation } from "react-i18next";
import {
  Dialog,
  KilometerPriceForm,
  KilometerPriceFormProps,
} from "@components";

// Interface for Modal props, extending Form props and adding modal controls
export interface KilometerPriceModalProps extends Omit<
  KilometerPriceFormProps,
  "onCancel"
> {
  show: boolean;
  onClose: () => void;
  // onConfirm is inherited from KilometerPriceFormProps
}

export const KilometerPriceModal: FC<KilometerPriceModalProps> = ({
  show,
  onClose,
  onConfirm,
  initialPrice,
  initialVat,
}) => {
  const { t } = useTranslation(["common"]);

  return (
    <Dialog
      show={show}
      toggleModal={onClose} // Use onClose for toggling visibility
      title={t("price_model.distance.title")}
      hideButtons // Hide default Dialog buttons, form has its own
      dismissible // Allow closing by clicking outside
      content={
        // Pass relevant props down to the form
        <KilometerPriceForm
          initialPrice={initialPrice}
          initialVat={initialVat}
          onConfirm={onConfirm}
          onCancel={onClose} // Form's cancel button triggers modal close
        />
      }
    />
  );
};
